import { AdministrativeAreaDTO } from './AdministrativeAreaDTO'
import { AdministrativeAreaRaw } from './AdministrativeAreaRaw'

export class AdministrativeAreaDTOFactory {
  static fromRaw(raw: AdministrativeAreaRaw): AdministrativeAreaDTO {
    return new AdministrativeAreaDTO(raw.area_name, raw.return_period)
  }
}
